module.exports = __webpack_public_path__ + "img/title2-en.9c2feef9.png";